import { SanityCtas } from "./FeaturedSnippetModule.d"
import tw from "twin.macro"
import React from "react"
import { getCTALinkValue } from "../../../helpers"
import { ButtonLink } from "../../atoms/Button"

const FeaturedSnippetCTAs: React.FC<SanityCtas> = ({
  _key,
  ctas,
  justification,
}) => {
  return (
    <div
      css={[
        tw`flex gap-x-5`,
        justification == "center"
          ? tw`mx-auto justify-center`
          : justification == "right"
            ? tw`justify-end`
            : tw`justify-start`,
      ]}
      key={_key}
    >
      {ctas.map((cta, index) => {
        return (
          <div key={index} css={tw`mb-4`}>
            <ButtonLink
              {...{ [cta?.buttonType]: true }}
              to={getCTALinkValue(cta)}
              target={cta?.linkType === "external" ? "_blank" : "_self"}
              css={[
                tw`w-full col-span-1 whitespace-nowrap text-xs my-1 !px-4`,
                tw`lg:(w-auto)`,
                tw`xl:(!px-8)`,
              ]}
              key={cta?.title}
            >
              {cta?.title}
            </ButtonLink>
          </div>
        )
      })}
    </div>
  )
}
export default FeaturedSnippetCTAs
